import { render, staticRenderFns } from "./PostBlockedContainer.vue?vue&type=template&id=47d4620c&"
import script from "./PostBlockedContainer.vue?vue&type=script&lang=js&"
export * from "./PostBlockedContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostBlockedContainer.vue"
export default component.exports